<template>
  <div class="divBox">
    <el-card :bordered="false" dis-hover class="ivu-mt box-card">
      <el-tabs v-model="thisForm.status" @tab-click="searchs" class="mb10">
        <el-tab-pane :label="`全部(${tablists.all || 0})`" name="all"/>
        <el-tab-pane :label="`待支付(${tablists.noPay || 0})`" name="0"/>
        <el-tab-pane :label="`待接单(${tablists.stayJoin || 0})`" name="10"/>
        <el-tab-pane :label="`待服务(${tablists.stayServe || 0})`" name="20"/>
        <el-tab-pane :label="`超时待服务(${tablists.overServe || 0})`" name="25"/>
        <el-tab-pane :label="`进行中(${tablists.underWay || 0})`" name="30"/>
        <el-tab-pane :label="`待评价(${tablists.comment || 0})`" name="40"/>
        <el-tab-pane :label="`已完成(${tablists.finished || 0})`" name="50"/>
        <el-tab-pane :label="`已取消(${tablists.stopCancel || 0})`" name="-1"/>
        <el-tab-pane :label="`退款申请(${tablists.refundApply || 0})`" name="-10"/>
        <el-tab-pane :label="`已退款(${tablists.stopRefund || 0})`" name="-20"/>
      </el-tabs>
      <div class="padding-add">
        <el-form ref="thisForm" :model="thisForm" size="small" inline label-position="right" @submit.native.prevent>
          <el-row align="top">
            <el-col :span="8">
              <el-form-item label="订单搜索：">
                <el-input placeholder="请输入搜索关键字" v-model="thisForm.keyword" class="input-with-select">
                  <el-select v-model="thisForm.fieldKey" slot="prepend" style="width:80px" placeholder="请选择">
                    <el-option label="全部" value="all"></el-option>
                    <el-option label="订单号" value="ordersn"></el-option>
                    <el-option label="用户UID" value="uid"></el-option>
                  </el-select>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="服务分类：">
                <el-select v-model="thisForm.cateId" placeholder="请选择" clearable filterable @change="searchs">
                  <el-option v-for="(item,index) in cateList" :key="index" :label="item.html + item.title" :value="item.id" :disabled="item.pid === 0"/>
                </el-select>
              </el-form-item>
            </el-col>
            <template v-if="collapse">
              <el-col :span="8">
                <el-form-item label="支付方式：">
                  <el-radio-group v-model="thisForm.payType" @change="searchs">
                    <el-radio-button v-for="item in payList" :label="item.val" :key="item.id">{{ item.label }}</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="时间选择：" label-for="user_time_type">
                  <el-select v-model="thisForm.timeKey" placeholder="请选择访问情况" element-id="userTimeType" clearable>
                    <el-option value="add_time" label="下单时间"></el-option>
                    <el-option value="pay_time" label="支付时间"></el-option>
                    <el-option value="book_time" label="预约时间"></el-option>
                    <el-option value="appoint_time" label="指派时间"></el-option>
                    <el-option value="finish_time" label="完成时间"></el-option>
                    <el-option value="cancel_time" label="取消时间"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="thisForm.timeKey">
                <el-form-item label="时间：" label-for="timeType">
                  <el-date-picker
                    :editable="false"
                    @change="onchangeTime"
                    v-model="timeVal"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="daterange" placeholder="请选择时间"
                    style="width: 100%;"></el-date-picker>
                </el-form-item>
              </el-col>
            </template>
            <el-col :span="8">
              <el-form-item>
                <el-button type="primary" icon="ios-search" label="default" class="mr15" @click="searchs">搜索</el-button>
                <el-button @click="reset">重置</el-button>
                <a class="ivu-ml-8 font14 ml10" @click="collapse = !collapse">
                  <template v-if="!collapse">
                    展开
                    <i class="ios-arrow-down"/>
                  </template>
                  <template v-else>
                    收起
                    <i class="ios-arrow-up"/>
                  </template>
                </a>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-divider dashed/>
        <el-row justify="space-between">
          <el-button icon="ios-share-outline" @click="exports" :loading="exportLoading">导出</el-button>
        </el-row>
      </div>
      <el-table :data="list" ref="table" @selection-change="handleSelectionChange" class="mt25" v-loading="loading">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="订单信息" width="160">
          <template slot-scope="{ row, index }">
            <div>{{ row.ordersn }}</div>
            <div v-if="row.isDel === 1" style="color: #ed4014; display: block">用户已删除</div>
          </template>
        </el-table-column>
        <el-table-column label="用户信息" min-width="120">
          <template slot-scope="{ row, index }">
            <div>下单用户：{{ row.linkName }}|<span>{{ row.linkMobile }}</span></div>
            <div>下单地址：{{ row.userAddress }}</div>
          </template>
        </el-table-column>
        <el-table-column label="服务信息" min-width="150">
          <template slot-scope="{ row, index }">
            <div>预约项目：{{ row.itemName }}</div>
            <div>预约时间：{{ row.bookTimeDesc }}</div>
            <div>应付金额：{{ row.originalPrice || '---' }}</div>
            <div>实付金额：{{ row.payPrice || '---' }}</div>
            <div>
              <el-tag :color="row.statusColor" effect="dark" :hit="false">{{ row.statusDesc }}</el-tag>
              <el-tag style="margin-left: 10px;" v-if="row.payTime" :color="row.payTypeColor" effect="dark" :hit="false">{{ row.payTypeDesc }}</el-tag>
              <el-tag style="margin-left: 10px;" v-else color="default" effect="dark" :hit="false">未支付</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="服务技师" min-width="120">
          <template slot-scope="{ row, index }">
            <div>{{ row.staffName }}|<span style="color: blue;">{{ row.serviceStaffId }}</span></div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="费用信息" min-width="150">
          <template slot-scope="{ row, index }">

          </template>
        </el-table-column> -->
        <el-table-column label="时间" min-width="150">
          <template slot-scope="{ row, index }">
            <div>下单时间：{{ row.addTimeDesc }}</div>
            <div v-if="row.payTime">支付时间：{{ row.payTimeDesc }}</div>
            <div v-if="row.handleTime">接单时间：{{ row.handleTimeDesc }}</div>
            <div v-if="row.signTime">签到时间：{{ row.signTimeDesc }}</div>
            <div v-if="row.finishTime">完成时间：{{ row.finishTimeDesc }}</div>
            <div v-if="row.cancelTimeDesc">取消时间：{{ row.cancelTimeDesc }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="到达打卡">
          <template slot-scope="{ row ,index}">
            <div class="tabBox_img">
              <el-image
                v-for="(item,index) in row.signImgsArray"
                style="width: 100px; height: 100px"
                :src="item"
                :preview-src-list="row.signImgsArray">
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="完成打卡">
          <template slot-scope="{ row ,index}">
            <div class="tabBox_img">
              <el-image
                v-for="(item,index) in row.staffImgsArray"
                style="width: 100px; height: 100px"
                :src="item"
                :preview-src-list="row.staffImgsArray">
              </el-image>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column label="备注">
          <template slot-scope="{ row, index }">
            <div>客户备注：{{ row.remark }}</div>
            <!-- <div>平台备注：{{row.remarkSaler}}</div> -->
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="operate" fixed="right">
          <template slot-scope="{ row, index }">
            <el-button v-if="row.status !== -10" type="primary" @click="toOrderInfo(row)" size="small" icon="md-alert">
              订单详情
            </el-button>
            <el-button v-if="row.status === -10" type="primary" @click="orderRefund(row)" size="small" icon="md-cash">
              处理退款
            </el-button>
            <el-divider direction="vertical"></el-divider>
            <template>
              <el-dropdown type="primary" @command="changeMenu(row, $event)">
                <a href="javascript:void(0)">更多<i class="ios-arrow-down"/></a>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="row.status === 10" command="50">确认接单</el-dropdown-item>
                  <el-dropdown-item v-if="row.status >= 0 && row.status < 30" command="60">改派技师</el-dropdown-item>
                  <!-- 工作流程操作 -->
                  <el-dropdown-item v-if="canDepart(row)" command="70">技师出发</el-dropdown-item>
                  <el-dropdown-item v-if="canArrive(row)" command="71">技师到达</el-dropdown-item>
                  <el-dropdown-item v-if="canPunchCard(row)" command="72">现场打卡</el-dropdown-item>
                  <el-dropdown-item v-if="canStartService(row)" command="73">开始服务</el-dropdown-item>
                  <el-dropdown-item v-if="canFinishService(row)" command="74">完成服务</el-dropdown-item>
                  <el-dropdown-item v-if="canComment(row)" command="75">技师评价</el-dropdown-item>
                  <el-dropdown-item command="40">订单日志</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          background
          :page-size="thisForm.limit"
          :current-page="thisForm.page"
          :total="total"
          :page-sizes="[20, 40, 60, 80]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="pageChange"
        />
      </div>
    </el-card>
    <!-- 退款处理 -->
    <order-refund ref="refund" :orderId="orderId" @submitOk="submitOk" @clearId="()=>{ orderId = 0 }"></order-refund>
    <!-- 订单日志 -->
    <order-log ref="log"></order-log>
    <!-- 改派技师弹窗 -->
    <el-dialog title="改派技师" :visible.sync="reassignVisible" width="500px" class="reassign-dialog">
      <div class="reassign-content">
        <div class="reassign-header">
          <div class="current-staff">
            <span class="label">当前技师：</span>
            <span class="value">{{ currentOrder.staffName || '未指派' }}</span>
          </div>
          <el-input v-model="staffSearchForm.keyword" placeholder="搜索技师名称" size="small" clearable prefix-icon="el-icon-search" class="search-input" @keyup.enter.native="searchStaffList"></el-input>
        </div>
        <div class="staff-list" v-loading="staffListLoading">
          <div
            v-for="item in staffList"
            :key="item.id"
            class="staff-item"
            :class="{ 'is-disabled': item.id === currentOrder.serviceStaffId, 'is-selected': selectedStaffId === item.id }"
            @click="item.id !== currentOrder.serviceStaffId && (selectedStaffId = item.id)">
            <div class="staff-avatar">
              <el-avatar :size="48" :src="item.thumb">
                <i class="el-icon-user-solid"></i>
              </el-avatar>
            </div>
            <div class="staff-info">
              <div class="staff-name">{{ item.name }}</div>
              <div class="staff-meta">ID: {{ item.id }} | {{ item.phone }}</div>
            </div>
            <div class="staff-check">
              <i v-if="selectedStaffId === item.id" class="el-icon-success"></i>
              <span v-if="item.id === currentOrder.serviceStaffId" class="current-tag">当前</span>
            </div>
          </div>
          <div v-if="staffList.length === 0 && !staffListLoading" class="empty-tip">
            <i class="el-icon-warning-outline"></i>
            <span>暂无技师数据</span>
          </div>
        </div>
        <div class="staff-pagination">
          <el-pagination
            small
            background
            layout="prev, pager, next"
            :page-size="staffSearchForm.limit"
            :current-page="staffSearchForm.page"
            :total="staffTotal"
            @current-change="staffPageChange">
          </el-pagination>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reassignVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmReassign" :loading="reassignLoading" :disabled="!selectedStaffId">确认改派</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import {orderListApi as getOrderList, orderStatusNumApi as getTabsData, orderExcelApi as exportOrder, orderDetailApi as getCateTierList, orderListApi as confirmAcceptOrder, orderListApi as getServiceStaffList, orderListApi as reassignStaff, orderListApi as technicianDepart, orderListApi as technicianArrive, orderListApi as technicianPunchCard, orderListApi as startService, orderListApi as finishService, orderListApi as technicianComment} from '@/api/order';
import orderRefund from './handle/orderRefund.vue';
import orderLog from './handle/orderLog.vue';

export default {
  name: 'service_order',
  components: {
    orderRefund,
    orderLog,
  },
  data() {
    return {
      grid: {
        xl: 8,
        lg: 8,
        md: 12,
        sm: 24,
        xs: 24,
      },
      loading: false,
      spinShow: false,
      collapse: false,
      options: {
        shortcuts: [
          {
            text: '今天',
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()));
              return [start, end];
            },
          },
          {
            text: '昨天',
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.setTime(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1)));
              end.setTime(end.setTime(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())));
              return [start, end];
            },
          },
          {
            text: '最近7天',
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.setTime(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 6)));
              return [start, end];
            },
          },
          {
            text: '最近30天',
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.setTime(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 29)));
              return [start, end];
            },
          },
          {
            text: '本月',
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.setTime(new Date(new Date().getFullYear(), new Date().getMonth(), 1)));
              return [start, end];
            },
          },
          {
            text: '本年',
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.setTime(new Date(new Date().getFullYear(), 0, 1)));
              return [start, end];
            },
          },
        ],
      },
      thisForm: {
        page: 1,
        limit: 20,
        status: 'all',
        keyword: '',
        fieldKey: 'all',
        payType: '',
        timeKey: '',
        cateId: '',
        time: '',
        ids: '',
      },
      payList: [
        {label: '全部', val: ''},
        {label: '余额支付', val: 'yue'},
        {label: '微信支付', val: 'weixin'},
        {label: '支付宝支付', val: 'alipay'},
      ],
      list: [],
      selectionList:[],
      tablists: [],
      timeVal: [],
      total: 0,
      cateList: [],
      tabs: [
        {
          type: 'all',
          label: '全部',
        },
        {
          type: '0',
          label: '待支付',
        },
        {
          type: '10',
          label: '待接单',
        },
        {
          type: '20',
          label: '待服务',
        },
        {
          type: '25',
          label: '超时待服务',
        },
        {
          type: '30',
          label: '进行中',
        },
        {
          type: '40',
          label: '待评价',
        },
        {
          type: '50',
          label: '已完成',
        },
        {
          type: '-1',
          label: '已取消',
        },
        {
          type: '-10',
          label: '退款申请',
        },
        {
          type: '-20',
          label: '已退款',
        },
      ],
      orderId: 0, // 当前订单id
      city_id: 0, // 当前城市id
      service_user_id: 0, // 当前员工id
      selectedIds: new Set(), //选中合并项的id:0
      ids: '',
      exportLoading: false, // 导出锁
      reassignVisible: false, // 改派技师弹窗
      reassignLoading: false, // 改派加载中
      currentOrder: {}, // 当前操作的订单
      staffList: [], // 技师列表
      staffTotal: 0, // 技师总数
      staffListLoading: false, // 技师列表加载中
      selectedStaffId: null, // 选中的技师ID
      staffSearchForm: {
        page: 1,
        limit: 10,
        keyword: '',
        status: 1
      }, // 技师搜索表单
    };
  },
  computed: {
    ...mapState('media', ['isMobile']),
    labelWidth() {
      return this.isMobile ? undefined : 75;
    },
    labelPosition() {
      return this.isMobile ? 'top' : 'left';
    },
  },
  watch: {
    $route(to, from) {
      if (this.$route.query.status) {
        this.thisForm.status = this.$route.query.status;
        this.getList();
      }
    },
  },
  created() {
    if (this.$route.query.status) {
      this.thisForm.status = this.$route.query.status;
    }
    this.getCategory();
    this.getList();
  },
  mounted() {
    if (this.$route.query.status) {
      this.thisForm.status = this.$route.query.status;
    }
    this.getTabs();
  },
  methods: {
    // 更多
    changeMenu(row, name) {
      this.orderId = row.id;
      switch (name) {
        case '10': // 订单详情
          this.toOrderInfo(row);
          break;
        case '20': // 升级订单
          this.openUpgrade(row);
          break;
        case '30': // 加钟记录
          this.openSubjoin(row);
          break;
        case '40': // 订单日志
          this.orderLog(row);
          break;
        case '50': // 确认接单
          this.confirmAccept(row);
          break;
        case '60': // 改派技师
          this.openReassign(row);
          break;
        case '70': // 模拟出发
          this.simulateDepart(row);
          break;
        case '71': // 模拟到达
          this.simulateArrive(row);
          break;
        case '72': // 模拟打卡
          this.simulatePunchCard(row);
          break;
        case '73': // 模拟开始服务
          this.simulateStartService(row);
          break;
        case '74': // 模拟完成服务
          this.simulateFinishService(row);
          break;
        case '75': // 模拟技师评价
          this.simulateComment(row);
          break;
      }
    },
    // 打开改派技师弹窗
    openReassign(row) {
      this.currentOrder = row;
      this.selectedStaffId = null;
      this.staffSearchForm.page = 1;
      this.staffSearchForm.keyword = '';
      this.reassignVisible = true;
      this.getStaffList();
    },
    // 获取技师列表
    getStaffList() {
      this.staffListLoading = true;
      getServiceStaffList(this.staffSearchForm).then(data => {
        this.staffList = data.list || [];
        this.staffTotal = data.total || 0;
        this.staffListLoading = false;
      }).catch(res => {
        this.staffListLoading = false;
        this.$message.error(res.msg || '获取技师列表失败');
      });
    },
    // 技师列表搜索
    searchStaffList() {
      this.staffSearchForm.page = 1;
      this.getStaffList();
    },
    // 技师列表分页
    staffPageChange(page) {
      this.staffSearchForm.page = page;
      this.getStaffList();
    },
    // 确认改派技师
    confirmReassign() {
      if (!this.selectedStaffId) {
        this.$message.warning('请选择技师');
        return;
      }
      this.reassignLoading = true;
      reassignStaff({ id: this.currentOrder.id, staffId: this.selectedStaffId }).then(() => {
        this.$message.success('改派成功');
        this.reassignVisible = false;
        this.getList();
        this.getTabs();
      }).catch(res => {
        this.$message.error(res.msg || '改派失败');
      }).finally(() => {
        this.reassignLoading = false;
      });
    },
    // 打开加钟订单弹窗
    openSubjoin(row) {
      this.$refs.subjoin.open_modal = true;
      this.orderId = row.id;
      this.$refs.subjoin.thisForm.order_id = row.id;
      this.$nextTick(() => {
        this.$refs.subjoin.getList();
      })
    },
    // 打开升级订单弹窗
    openUpgrade(row) {
      this.$refs.upgrade.open_modal = true;
      this.orderId = row.id;
      this.$refs.upgrade.thisForm.order_id = row.id;
      this.$nextTick(() => {
        this.$refs.upgrade.getList();
      })
    },
    
    // 工作流程状态验证方法
    canDepart(row) {
      return row.status === 20 && row.isDepart === 0;
    },
    canArrive(row) {
      return row.status === 20 && row.isDepart === 1;
    },
    canPunchCard(row) {
      return row.status === 20 && row.isDepart === 2;
    },
    canStartService(row) {
      return row.status === 20 && row.isDepart === 3;
    },
    canFinishService(row) {
      return row.status === 30;
    },
    canComment(row) {
      return row.status === 40;
    },
    
    // 工作流程模拟方法
    simulateDepart(row) {
      this.$confirm('确认模拟技师出发操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        technicianDepart(row.id).then(() => {
          this.$message.success('模拟技师出发成功');
          this.getList();
          this.getTabs();
        }).catch(res => {
          this.$message.error(res.msg || '操作失败');
        });
      });
    },
    
    simulateArrive(row) {
      this.$confirm('确认模拟技师到达操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        technicianArrive(row.id).then(() => {
          this.$message.success('模拟技师到达成功');
          this.getList();
          this.getTabs();
        }).catch(res => {
          this.$message.error(res.msg || '操作失败');
        });
      });
    },
    
    simulatePunchCard(row) {
      this.$confirm('确认模拟现场打卡操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          orderId: row.id,
          signContent: '管理员模拟打卡操作',
          signImgsArray: []
        };
        technicianPunchCard(data).then(() => {
          this.$message.success('模拟现场打卡成功');
          this.getList();
          this.getTabs();
        }).catch(res => {
          this.$message.error(res.msg || '操作失败');
        });
      });
    },
    
    simulateStartService(row) {
      this.$confirm('确认模拟开始服务操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        startService(row.id).then(() => {
          this.$message.success('模拟开始服务成功');
          this.getList();
          this.getTabs();
        }).catch(res => {
          this.$message.error(res.msg || '操作失败');
        });
      });
    },
    
    simulateFinishService(row) {
      this.$confirm('确认模拟完成服务操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          orderId: row.id,
          staffRemark: '管理员模拟完成服务操作',
          staffImgsArray: []
        };
        finishService(data).then(() => {
          this.$message.success('模拟完成服务成功');
          this.getList();
          this.getTabs();
        }).catch(res => {
          this.$message.error(res.msg || '操作失败');
        });
      });
    },
    
    simulateComment(row) {
      this.$confirm('确认模拟技师评价操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          orderId: row.id,
          formContent: JSON.stringify({
            rating: 5,
            comment: '管理员模拟技师评价：服务满意，客户配合度很好'
          })
        };
        technicianComment(data).then(() => {
          this.$message.success('模拟技师评价成功');
          this.getList();
          this.getTabs();
        }).catch(res => {
          this.$message.error(res.msg || '操作失败');
        });
      });
    },
    
    // 获取分类
    getCategory() {
      // getCateTierList().then(async (data) => {
      //   this.cateList = data;
      // }).catch((res) => {
      //   this.$message.error(res.msg);
      // });
    },
    // 搜索
    searchs() {
      this.thisForm.page = 1;
      this.getTabs();
      this.getList();
    },
    // tabs数据
    getTabs() {
      this.spinShow = true;
      getTabsData().then(async (data) => {
        console.log('getTabsData', data);
        this.tablists = data.data;
        this.spinShow = false;
      }).catch((res) => {
        this.spinShow = false;
        this.$message.error(res.msg);
      });
    },
    // 订单列表
    getList() {
      this.loading = true;
      getOrderList(this.thisForm).then(async (data) => {
        this.list = data.data.list;
        this.total = data.data.total;
        this.loading = false;
      }).catch((res) => {
        this.loading = false;
        this.$message.error(res.msg);
      });
    },
    // 重置
    reset() {
      this.thisForm = {
        page: 1,
        limit: 20,
        status: 'all',
        keyword: '',
        fieldKey: 'all',
        payType: '',
        timeKey: '',
        cateId: '',
        time: '',
        ids: '',
      }
      this.getList();
      this.getTabs();
    },
    //导出
    exports() {
      if (this.exportLoading) return;
      this.thisForm.ids = this.ids;
      this.exportLoading = true;
      exportOrder(this.thisForm).then((data) => {
        this.exportLoading = false;
        location.href = data.fileName;
      }).catch((res) => {
        this.exportLoading = false;
        this.$message.error(res.msg);
      });
    },
    //执行完成刷新
    submitOk() {
      this.getList();
      this.getTabs();
    },
    // 订单详情
    toOrderInfo(row) {
      this.$router.push({path: `/onsite/order_detail/${row.id}`})
    },
    // 订单日志
    orderLog(row) {
      this.$refs.log.open_modal = true;
      this.$refs.log.thisForm.objId = row.id;
      this.$refs.log.thisForm.page = 1;
      this.$nextTick(() => {
        this.$refs.log.getList();
      });
    },
    show(type) {
      let viewer = this.$el.querySelector('.' + type).$viewer;
      viewer.show();
    },
    // 选择日期
    onchangeTime(e) {
      this.timeVal = e;
      this.thisForm.time = this.timeVal[0] ? this.timeVal.join('_') : '';
    },
    // 分页
    pageChange(index) {
      this.thisForm.page = index;
      this.getList();
    },
    handleSizeChange(val) {
      this.thisForm.limit = val;
      this.getList();
    },
    handleSelectionChange(val) {
      this.selectionList = val;
      const data = [];
      this.selectionList.map((item) => {
        data.push(item.id);
      });
      this.selectedIds = data;
      this.thisForm.ids = data.join(',');
      this.ids = data.join(',');
    },
    // 订单退款
    orderRefund(row) {
      this.$refs.refund.modals = true;
      this.$refs.refund.is_remark = true;
      this.orderId = row.id;
      this.$nextTick((e) => {
        this.$refs.refund.getOrderInfo();
      });
    },
    // 退款详情
    orderRemark(row) {
      this.$refs.refund.modals = true;
      this.$refs.refund.is_remark = false;
      this.orderId = row.id;
      this.$nextTick((e) => {
        this.$refs.refund.getOrderInfo();
      });
    },
    // 报备记录
    getOrderReport(row) {
      this.$refs.report.thisForm.id = row.id;
      this.$refs.report.open_modal = true;
      this.orderId = row.id;
      this.$nextTick(() => {
        this.$refs.report.getList();
      })
    },
    // 确认接单（代替技师接单）
    confirmAccept(row) {
      this.$confirm('确定要代替技师确认接单吗？', '确认接单', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        confirmAcceptOrder({ id: row.id }).then(() => {
          this.$message.success('接单成功');
          this.getList();
          this.getTabs();
        }).catch((res) => {
          this.$message.error(res.msg || '操作失败');
        });
      }).catch(() => {});
    },
  },
};
</script>

<style scoped>

::v-deep .el-tag {
  border: none;
}

.tabBox_img {
  display: flex;
}
.el-select .el-input {
  width: 100% !important;
}

.input-with-select .el-select .el-input {
  width: 90px !important;
}

/* 改派技师弹窗样式 */
::v-deep .reassign-dialog .el-dialog__body {
  padding: 0;
}

.reassign-content {
  padding: 0;
}

.reassign-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #ebeef5;
}

.current-staff {
  font-size: 14px;
}

.current-staff .label {
  color: #909399;
}

.current-staff .value {
  color: #303133;
  font-weight: 500;
}

.search-input {
  width: 180px;
}

.staff-list {
  max-height: 350px;
  overflow-y: auto;
}

.staff-item {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: all 0.2s ease;
}

.staff-item:hover {
  background-color: #f5f7fa;
}

.staff-item.is-selected {
  background-color: #ecf5ff;
  border-left: 3px solid #409EFF;
}

.staff-item.is-disabled {
  cursor: not-allowed;
  background-color: #f5f5f5;
}

.staff-item.is-disabled .staff-name,
.staff-item.is-disabled .staff-meta {
  color: #c0c4cc;
}

.staff-avatar {
  flex-shrink: 0;
}

.staff-info {
  flex: 1;
  margin-left: 14px;
}

.staff-name {
  font-size: 15px;
  font-weight: 500;
  color: #303133;
  line-height: 1.4;
}

.staff-meta {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.staff-check {
  flex-shrink: 0;
  margin-left: 10px;
}

.staff-check .el-icon-success {
  font-size: 20px;
  color: #67C23A;
}

.current-tag {
  display: inline-block;
  padding: 2px 8px;
  font-size: 12px;
  color: #909399;
  background: #f0f0f0;
  border-radius: 4px;
}

.empty-tip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #909399;
}

.empty-tip i {
  font-size: 40px;
  margin-bottom: 10px;
}

.dialog-footer {
  text-align: right;
}

.staff-pagination {
  display: flex;
  justify-content: center;
  padding: 12px 0;
  border-top: 1px solid #ebeef5;
}
</style>
